import React, { Component } from "react";
import ContactInfo from "./ContactInfo";
import AddressInfo from "./AddressInfo";
import SocialIconsContainer from "./SocialIconsContainer";
import { css } from "glamor";

class Footer extends Component {
  render() {
    let footerCss = css({
      backgroundColor: "#ddd",
      padding: "10px 0px",
      fontSize: "0.8em",
      lineHeight: "1.8em",
      color: "black",
      marginTop: "40px",
    });

    let footerContainerCss = css(
      {
        maxWidth: "875px",
        marginLeft: "auto",
        marginRight: "auto",
      },
      {
        "@media(max-width: 900px)": {
          paddingLeft: "20px",
          paddingRight: "20px",
        },
      },
      {
        "@media(max-width: 640px)": {
          textAlign: "center",
        },
      }
    );

    let copyrightCss = css({
      textAlign: "center",
      fontSize: "0.75em",
      padding: "20px 0px",
    });

    let currentYear = new Date().getFullYear();

    return (
      <footer>
        <div className={footerCss}>
          <div className={footerContainerCss}>
            <SocialIconsContainer />
            <AddressInfo />
            <ContactInfo />
          </div>
        </div>
        <p className={copyrightCss}>
          &copy; Copyright 2018-{currentYear} Claudio Saelens
          <br />
        </p>
      </footer>
    );
  }
}

export default Footer;
